import { Info, Shield, Speed } from '@mui/icons-material';
import { Box, Paper, styled, Typography, useTheme } from '@mui/material';
import { FC } from 'react';

interface MileageInfoPanelProps {
	currentMileage: number;
	newMileage: number;
}

const InfoItem = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'flex-start',
	marginBottom: theme.spacing(2),
	'& .MuiSvgIcon-root': {
		marginRight: theme.spacing(2),
		color: theme.palette.primary.main,
	},
}));

const MileageInfoPanel: FC<MileageInfoPanelProps> = ({ currentMileage, newMileage }) => {
	const theme = useTheme();

	return (
		<Box sx={{ mb: 3 }}>
			<Paper
				elevation={0}
				sx={{
					p: 2.5,
					borderRadius: 2,
					backgroundColor: theme.palette.grey[100],
					border: `1px solid ${theme.palette.grey[300]}`,
				}}
			>
				<InfoItem>
					<Info color='info' fontSize='medium' />
					<Box>
						<Typography variant='body2' fontWeight='medium' color='text.primary'>
							About your mileage change
						</Typography>
						<Typography variant='body2' color='text.secondary'>
							This price reflects the additional premium for your increased mileage allowance, calculated on a pro-rata
							basis for the remainder of your policy term.
						</Typography>
					</Box>
				</InfoItem>

				<InfoItem>
					<Speed color='info' fontSize='medium' />
					<Box>
						<Typography variant='body2' fontWeight='medium' color='text.primary'>
							New annual mileage: {newMileage} miles
						</Typography>
						<Typography variant='body2' color='text.secondary'>
							Your previous annual mileage was {currentMileage} miles.
						</Typography>
					</Box>
				</InfoItem>

				<InfoItem>
					<Shield color='info' fontSize='medium' />
					<Box>
						<Typography variant='body2' fontWeight='medium' color='text.primary'>
							Your cover remains the same
						</Typography>
						<Typography variant='body2' color='text.secondary'>
							All other aspects of your policy coverage remain unchanged.
						</Typography>
					</Box>
				</InfoItem>
			</Paper>
		</Box>
	);
};

export default MileageInfoPanel;
